export const homeAbout = {
  eyebrow: "We Are Leading Experts",
  heading: "Sewing Custom Drapery & Installing Premium Window Coverings",
  paragraphs: [
    "We specialize in creating high-end window coverings, blinds, pillows, and custom furnishings with couture-level attention to detail and quality.",
    "Our clients return to us time and again for the exceptional craftsmanship and the detail-oriented designs that we deliver.",
  ],
  image: {
    src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_500,q_auto,w_800/f_auto/q_auto/v1678571453/marilyns-windows/index/pexels-cottonbro-studio-4614127-min_jd6fc2.webp",
    alt: "A horizontal accessory hook in a sewing workroom, holding various sewing materials such as piping and rolls of velcro. The blurred background suggests a busy environment, while the focus on the hook and its contents suggests organization and attention to detail. These materials are used to create custom drapery and window treatments.",
    caption: "Organized Sewing Supplies for Custom Drapery",
    dataPin: "A horizontal accessory hook. The hook is used to organize and hold various sewing materials, including piping and rolls of velcro, which are necessary for creating custom drapery and window treatments. The blurred background adds a sense of activity and motion to the image, while the focus on the hook and its contents highlights the importance of organization and attention to detail in sewing projects.",
    width: 800,
    height: 500,
  },
};

export const homeAboutSecondary = {
  eyebrow: "Milton & Surrounding Areas",
  heading: "Handcrafted Window Treatments for Homes & Businesses",
  paragraph:
    "For many years, we have been expertly creating custom window treatments for homes and businesses across Oakville, Burlington, Mississauga, Georgetown, Milton and surrounding areas, bringing a touch of elegance to every space we serve.",
  image: {
    src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_500,q_auto,w_800/f_auto/q_auto/v1678571454/marilyns-windows/index/pexels-cottonbro-studio-4614237-min_nzlctl.webp",
    alt: "A close-up of a sewing machine being used to make custom drapery in a busy sewing workroom.",
    caption: "Drapery in the Making",
    dataPin: "A sewing machine creating custom drapery in Marilyn's workroom.",
    width: 800,
    height: 500,
  },
};

export const homeServices = {
  backgroundImage:
    "https://res.cloudinary.com/ryan-pilar/image/upload/f_auto/q_auto/v1667358106/marilyns-windows/backgrounds-banners/fabric-bolts_pukzuj.jpg",
  heading: "Services - a quick view",
  introduction: [
    "We are a Canadian workroom! Specializing in high-end blinds, shades, and shutters, and we also love to finish off rooms and spaces with custom throw pillows, cushions, and other soft furnishings.",
    "Each piece we work on is meticulously handcrafted and sewn with the finest materials, premium fabrics, and top-of-the-line hardware.",
  ],
  servicesPageLead:
    "We have the best window solutions to match your needs, whether you are perfecting an interior design or considering energy efficiency, privacy, automation, light filtering & blackout, etc. Learn more on our",
  leftItems: [
    {
      counter: 0,
      title: "Custom Drapery",
      description:
        "Stitched with the finest quality materials & textiles, and installed by a team of experts.",
    },
    {
      counter: 1,
      title: "Blinds & Smart Blinds",
      description:
        "Control light and privacy. Comes in a variety of materials, like wood, metal, vinyl, and can be made to block or filter light.",
    },
    {
      counter: 5,
      title: "Window Seats & Throw Pillows",
      description:
        "Amazing window seat design ideas to tie the room together.",
    },
  ],
  rightItems: [
    {
      counter: 3,
      title: "Custom Drapery Hardware",
      description:
        "Impressive curtain rods and drapery hardware are necessary for stunning drapes.",
    },
    {
      counter: 4,
      title: "Sunset, Shadow Magic & Silhouette-Like Shades",
      description: "Don't be fooled, this blind goes by many different names!",
    },
    {
      counter: 2,
      title: "Shutters",
      description:
        "We help you pick all the right options, sizes and colours and are experts at oddly shaped windows.",
    },
  ],
  locations: [
    "Milton",
    "Georgetown",
    "Burlington",
    "Oakville",
    "Mississauga",
    "and surrounding areas...",
  ],
};

export const homeSuppliers = [
  {
    title: "Equus Fabrics",
    website: "https://equusfabrics.com/",
    image: {
      src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fit,e_brightness:0,h_120,q_auto,w_200/f_auto/q_auto/v1673125274/marilyns-windows/logos/equus-logo-4_ztloiz.webp",
      alt: "Equus Fabrics Logo",
    },
  },
  {
    title: "Alta Window Fashions",
    website: "https://www.altawindowfashions.ca/",
    image: {
      src: "https://res.cloudinary.com/ryan-pilar/image/upload/q_auto/f_auto/q_auto/v1673120812/marilyns-windows/logos/alta-logo_jfpnvc.webp",
      alt: "Alta Window Fashions",
    },
  },
  {
    title: "Shadex",
    website: "https://www.shadex.com/",
    image: {
      src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fit,h_120,q_auto,w_200/f_auto/q_auto/v1673126351/marilyns-windows/logos/logo-shadex_cvouku.webp",
      alt: "Shadex Logo",
    },
  },
  {
    title: "Unique Fine Fabrics",
    website: "https://uniquefinefabrics.com/",
    image: {
      src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fit,e_brightness:80,h_120,q_auto,w_200/f_auto/q_auto/v1673125270/marilyns-windows/logos/unique-fabrics-logo_vxrbdg.webp",
      alt: "Unique Fine Fabrics Logo",
    },
  },
  {
    title: "Soletex",
    website: "https://www.soletexfabrics.com/",
    image: {
      src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fit,e_brightness:35,h_120,q_auto,w_200/f_auto/q_auto/v1673124720/marilyns-windows/logos/soletex-logo_vhwklz.webp",
      alt: "Soletex Fabrics",
    },
  },
  {
    title: "Robert Allen",
    website: "https://robertallendesign.com/",
    image: {
      src: "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,e_sharpen:100,g_auto,h_120,q_auto,w_200/f_auto/q_auto/v1673116463/marilyns-windows/logos/robert-allen-logo_qkrnuq.webp",
      alt: "Robert Allen logo",
    },
  },
];

export const homeTestimonials = {
  backgroundImage:
    "https://res.cloudinary.com/ryan-pilar/image/upload/f_auto/q_auto/v1667453602/marilyns-windows/backgrounds-banners/ptn-1_cvy1fm.png",
  items: [
    {
      fullName: "Homeowner",
      position: "Milton, Ontario",
      description:
        "Fabulous! Marilyn has provided great service… with our original blinds and then with replacements 15 years later! I had an issue and she took care of it personally. I really appreciated her help.",
    },
    {
      fullName: "GUNDING & HANS LLP",
      position: "Barristers & Solicitors",
      description:
        "The difference in the quality is extreme. Finally, when you can have warranties and worry-free assistance years after you have ordered the product, it is remarkable and reaffirming as to why the investment is so worthwhile.",
    },
    {
      fullName: "Homeowner",
      position: "Ogoko, Ontario",
      description:
        "Drapes For The Main Room In The Cottage. Gorgeous drapes that were installed into a very difficult spot. I was extremely impressed with how well the drapes functioned and how beautiful they looked. Marilyn and her installer did an amazing job.",
    },
    {
      fullName: "Brenda",
      position: "Acton, Ontario",
      description:
        "Many Project Locations Over Many Years... Whether a small project of one room to the largest of a 7,000 Sq ft new build, always, above and beyond service, quality and professionalism, service like no other. Very Refreshing working with Marilyn.",
    },
    {
      fullName: "Ellen Hughes",
      position: "Milton, Ontario",
      description:
        "We were first introduced to Marilyn’s Windows & Interiors years ago and they have been our go-to even since. Marilyn & her team will not disappoint.",
    },
    {
      fullName: "Clara Bella",
      position: "Vaughn, Ontario",
      description:
        "Marilyn’s service is extremely responsive, tailored and efficient. Everything was delivered and installed as anticipated with timing - if not a bit earlier even. Definitely recommend!",
    },
    {
      fullName: "Stephen Burke",
      position: "Key Account Executive",
      description:
        "It was a pleasure working with her. Though our install was 6 years ago, she continues to serve, long after the sale was made. I would not hesitate to work with her again, or recommend her to others, who are looking for the best quality window treatments.",
    },
  ],
};
